import { Button } from "@website/ui/button";
import { memo, useEffect, useState } from "react";

const Component = ({
  onClick,
  className,
  text,
  icon
}: {
  onClick: () => void;
  className?: string;
  text: string;
  icon?: JSX.Element | null;
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const syncVisibility = () => {
      const shouldBeVisible = window.scrollY > 0;
      setIsVisible((previous) =>
        previous === shouldBeVisible ? previous : shouldBeVisible
      );
    };

    const handleScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;

      requestAnimationFrame(() => {
        syncVisibility();
        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    syncVisibility();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Button
      StartIcon={icon}
      className={`shadow-4 !fixed z-[12] !flex w-[222px] whitespace-nowrap !bg-white !px-0 transition-transform duration-300 ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
      } ${className}`}
      color="secondary"
      onClick={onClick}
      size="large"
      text={text}
      variant="round-outline"
    />
  );
};

export const AnimatedButton = memo(Component);
